////////LIBRARY/////////
import { cloneDeep } from 'lodash'
///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, toastSuccessActionCreators, tagsManagerActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const getTags = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_TAGS(user)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)
		yield put(tagsManagerActionCreators.getTagsSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(tagsManagerActionCreators.getTagsFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const createTag = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.CREATE_TAG(user)

	const dataFormat = {
		name: payload.tag.tagName,
		isPrivate: true,
	}

	yield put(globalLoadingActionCreators.startLoading())
	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, dataFormat)

		// Prepare data to be added on current list
		let item = cloneDeep(data.data)

		yield put(tagsManagerActionCreators.createTagSuccess(item))

		/* const modal = {
            level: 'validation',
            title: 'modal__tagManagement__create_placeholder',
            key: 'modal__tagManagement__create_validation_message',
            show: true,
            path: '',
            insideModalResponse: true
        }; */

		yield put(toastSuccessActionCreators.hydrateToast('toast__tagManagement__create'))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(tagsManagerActionCreators.createTagFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getTagDetail = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	user['requestType'] = payload.requestType
	const apiCall = R.GET_TAG_DETAIL(user)
	yield put(globalLoadingActionCreators.startLoading())

	let dataCall = {
		tags: payload.tagList,
	}

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, dataCall)

		yield put(tagsManagerActionCreators.getTagDetailSuccess(data.data, payload.requestType))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(tagsManagerActionCreators.getTagDetailFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const deleteTag = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const idTag = payload.idTag
	user['idTag'] = idTag
	let apiCall

	yield put(globalLoadingActionCreators.startLoading())

	apiCall = R.DELETE_TAG(user)

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(tagsManagerActionCreators.deleteTagSuccess(idTag))

		/*  const modal = {
            level: 'validation',
            title: 'modal__tagManagement__delete_placeholder',
            key: 'modal__tagManagement__delete_tag',
            show: true,
            path: '',
            insideModalResponse: true
        }; */

		yield put(toastSuccessActionCreators.hydrateToast('toast__tagManagement__delete'))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(tagsManagerActionCreators.deleteTagFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const updateTagHeader = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const idTag = payload.idTag
	user['idTag'] = idTag
	const apiCall = R.UPDATE_TAG_HEADER(user)
	const dataFormat = {
		name: payload.tag.tagName,
	}

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, dataFormat)

		yield put(tagsManagerActionCreators.updateTagHeaderSuccess(data.data))
		/* 
        const modal = {
            level: 'validation',
            title: 'modal__tagManagement__edit_placeholder',
            key: 'modal__tagManagement__edit_validation_message',
            show: true,
            path: '',
            insideModalResponse: true
        }; */

		yield put(toastSuccessActionCreators.hydrateToast('toast__tagManagement__update'))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(tagsManagerActionCreators.updateTagHeaderFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const updateTagContent = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	user['mode'] = payload.type
	const apiCall = R.UPDATE_TAG_CONTENT(user)
	const datas = payload.datas

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, datas)

		yield put(tagsManagerActionCreators.updateTagContentSuccess(data.data, payload.type, datas))
		/* 
        const modal = {
            level: 'validation',
            title: 'modal__tagManagement__validation_header',
            key: 'modal__tagManagement__validation_body',
            show: true,
            path: '',
            insideModalResponse: true
        };
 */

		yield put(toastSuccessActionCreators.hydrateToast('toast__tagManagement__applied'))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(tagsManagerActionCreators.updateTagContentFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_TAGS, getTags)
	yield takeLatest(ActionsTypes.CREATE_TAG, createTag)
	yield takeLatest(ActionsTypes.GET_TAG_DETAIL, getTagDetail)
	yield takeLatest(ActionsTypes.DELETE_TAG, deleteTag)
	yield takeLatest(ActionsTypes.UPDATE_TAG_HEADER, updateTagHeader)
	yield takeLatest(ActionsTypes.UPDATE_TAG_CONTENT, updateTagContent)
}

export default sagas
